import * as XLSX from "xlsx-js-style";

export const exportSaleData = ({
  nfsaType,
  distMonth,
  distYear,
  transMonth,
  transYear,
  commodities,
  commCodes,
  summaryData,
  totals,
  refreshTime,
}) => {
  const wb = XLSX.utils.book_new();

  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];
  const distMonthName = monthNames[parseInt(distMonth, 10) - 1] || distMonth;
  const transMonthName = monthNames[parseInt(transMonth, 10) - 1] || transMonth;

  const titleText =
    (nfsaType === "N" ? "NFSA" : "Non-NFSA") +
    ` Date wise sale for Allotted Month/Year ${distMonthName} '${distYear} and Distributed Month/Year ${transMonthName} and ${transYear} (in MTs)`;

  const header = ["S.No", "Distribution Date", ...commodities.map(c => c.commName)];

  const wsData = [];

  wsData.push([{
    v: titleText,
    s: { font: { bold: true, sz: 14 }, alignment: { horizontal: "center" } }
  }]);



  wsData.push(header);

  summaryData.forEach((row, idx) => {
    const rowData = [
      idx + 1,
      row.loginDateTime ? new Date(row.loginDateTime).toLocaleDateString("en-GB") : ""
    ];
    commCodes.forEach((code) => {
      rowData.push(row.dynamicFields?.[`comm_code_${code}`] || 0);
    });
    wsData.push(rowData);
  });

  const totalRow = ["", "Total"];
  commCodes.forEach((code) => {
    totalRow.push(totals[code] || 0);
  });
  wsData.push(totalRow);

  const refreshRow = new Array(commCodes.length).fill("");
  refreshRow.push(
    {
      v: "Refresh Time :",
      s: { font: { color: { rgb: "FF0000" }, bold: true }, alignment: { horizontal: "right" } }
    },
    {
      v: refreshTime,
      s: { font: { color: { rgb: "008000" }, bold: true }, alignment: { horizontal: "left" } }
    }
  );
  wsData.push(refreshRow);

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: header.length - 1 } }, 
    { s: { r: 1, c: 0 }, e: { r: 1, c: header.length - 1 } } 
  ];

  ws["!cols"] = header.map(() => ({ wch: 20 }));

  XLSX.utils.book_append_sheet(wb, ws, "Sale Data");
  XLSX.writeFile(wb, `SaleData_${distMonthName}_${distYear}_${transMonthName}_${transYear}.xlsx`);
};
